import { ProductLiteModel } from '../product/productLiteModel';
import { PipeInfoModel } from '../product/pipeInfoModel';
import { FittingsModel } from './fittingsModel';
import { FileModel } from '../fileModel';

export class HeathInstallModel {
    public pipeInstall: number;
    public products: Array<ProductLiteModel>;
    public additionalProducts: Array<ProductLiteModel>;
    public heathInstallWork: boolean;
    public pipeInfo: PipeInfoModel;
    public fittings: FittingsModel;
    public activeTab: number;
    public axonometryPdf: FileModel;
}